module.exports = __webpack_public_path__ + "img/ft-flip-ver.151c629e.svg";